import React from 'react';
import cn from 'classnames';
import expandVector from '../../../../../resource/statistics/expandVector.svg';
import styles from './HorizontalPlotSkeleton.module.scss';

const HorizontalPlotSkeleton = ({ size = 'Small', className, style }) => {
  return (
    <div
      className={cn(
        styles.horizontalBarPlot,
        size === 'Long' ? styles.long : styles.small,
        className
      )}
      style={style}
    >
      <div className={styles.row}>
        <div className={styles.title} />
        {size === 'Long' ? (
          <div className={styles.expandButton}>
            <img src={expandVector} />
          </div>
        ) : null}
      </div>

      <div className={styles.row}>
        <div className={styles.barSkeletons}>
          <div className={styles.first} />
          <div className={styles.sec} />
          <div className={styles.third} />
          <div className={styles.fourth} />
          <div className={styles.fifth} />
        </div>

        <div className={styles.fakeScrollbar}>
          <div className={styles.fakeScrollbarThumb} />
        </div>
      </div>
    </div>
  );
};

export default HorizontalPlotSkeleton;
